<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Account requests</h1>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <div class="row" style="margin-bottom: 40px;">
                <div class="col">
                    <div class="card bg-light" style="margin-bottom: 20px;">
                        <div class="card-body">
                            <div class="float-left">
                                <h5 class="card-title">Janusz Noszczyński</h5>
                                <h6 class="card-subtitle mb-2 text-muted">janusz@transparentchoice.com</h6>
                            </div>

                            <div class="float-right">
                                <button type="button" class="btn btn-success btn-sm">
                                    <i class="fa fa-check" aria-hidden="true"></i>
                                </button>

                                <button type="button" class="btn btn-danger btn-sm">
                                    <i class="fa fa-ban" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item">Default</li>
                            <li class="list-group-item">Playground</li>
                        </ul>
                        <div class="card-footer text-muted">
                            2 days ago
                        </div>
                    </div>
                </div>

                <div class="col">
                    <div class="card bg-light" style="margin-bottom: 20px;">
                        <div class="card-body">
                            <div class="float-left">
                                <h5 class="card-title">Dan Dures</h5>
                                <h6 class="card-subtitle mb-2 text-muted">dan@transparentchoice.com</h6>
                            </div>

                            <div class="float-right">
                                <button type="button" class="btn btn-success btn-sm">
                                    <i class="fa fa-check" aria-hidden="true"></i>
                                </button>

                                <button type="button" class="btn btn-danger btn-sm">
                                    <i class="fa fa-ban" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item">Prioritization 2021</li>
                            <li class="list-group-item">Prioritization 2022</li>
                            <li class="list-group-item">Secret</li>
                        </ul>
                        <div class="card-footer text-muted">
                            5 hours ago
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PageBase from "@common/PageBase";
    import "@common/AdminNavigationV2.vue";

    @Component
    export default class AccountRequestsPage extends mixins(PageBase) {
    }
</script>

<style scoped>
</style>